import React from 'react';
import style from './footer.module.scss';

const Challenge = () => (
  <iframe aria-hidden="true" className={style.challenge} src="/anf/auth" title="Fastly Challenge" />
);

export default Challenge;
